import { render, staticRenderFns } from "./ChatArchivos.vue?vue&type=template&id=ed95ac46&scoped=true&"
import script from "./ChatArchivos.vue?vue&type=script&lang=js&"
export * from "./ChatArchivos.vue?vue&type=script&lang=js&"
import style0 from "./ChatArchivos.vue?vue&type=style&index=0&id=ed95ac46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed95ac46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCarousel,
  VCarouselItem,
  VDialog,
  VFlex,
  VIcon,
  VImg,
  VLayout,
  VProgressCircular,
})
